import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './../assets/styles/homepageStyle.scss'
import HomeSection8 from './homepage/homesection8';
import SwiperCard from './common/swiperCard';
import CategoryCardSwiper from './common/categoryCardSwiper';
import HomeCardSection from './homepage/homeSection2/HomeCardSection';


const HomePage = () => {
    const [selectedCategory, setSelectedCategory] = useState("All");

    return (
        <div className='homePage'>
            <HomeSection8 />
            <div className='bg_wrapper mb-3 mb-md-4 mb-lg-5'>
                <h4 className='title-xl text-white fw-semibold text-center m-0 pb-3'>Choose your Category</h4>
                <CategoryCardSwiper
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                />
            </div>

            <Container className="pt-5">
                <div className="d-flex align-items-center gap-3">
                    {/* <div className="category-accent-line"></div> */}
                    <h2 className="title-md fw-bold m-0 text-uppercase letter-spacing-2">
                        {selectedCategory} <span className="text-muted fw-light">Collection</span>
                    </h2>
                </div>
            </Container>

            <HomeCardSection selectedCategory={selectedCategory} />
            <section className=' bg_dark position-relative'>
                <div className=' image_bg'>
                    <div className='content_bg sectionPadding2'>
                        <h4 className="title-xl text-white fw-semibold text-center m-0 pb-3">
                            Recently View Products
                        </h4>
                        <SwiperCard />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePage;
